import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const ExemptWisconsin = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Wisconsin Nonprofit Filing Requirements & Deadlines"
          description="Learn Wisconsin nonprofit filing rules, annual report deadlines, and compliance requirements to keep your nonprofit in good standing."
          keywords=" "
          canonical="nonprofit-taxes/wisconsin-state-filing-requirements/"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-wi-landing-img.webp" />
                <source srcSet="/assets/images/state-wi-landing-img.png" />
                <img
                  src="/assets/images/state-wi-landing-img.png"
                  alt="Wisconsin State Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">Wisconsin State</span>
                </span>{' '}
                Filing Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Nonprofits in Wisconsin must complete state formation, maintain
                annual reports, and follow IRS rules to stay in good standing
                and legally operate.
              </Typography>

              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=wisconsin`}
                  >
                    Get Started
                  </Button>
                 
                </Box>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-wi-landing-img-sm.webp" />
                <source srcSet="/assets/images/state-wi-landing-img-sm.png" />
                <img
                  src="/assets/images/state-wi-landing-img-sm.png"
                  alt="Wisconsin State Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Required Non-profit Forms
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 17, md: 17, sm: 16, xs: 16 },
              fontWeight: 400,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Nonprofits in Wisconsin must file key formation documents and annual
            reports to remain in compliance with state requirements.
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 5 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Wisconsin Department of Financial Institutions (DFI)
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Forms (Required for State Compliance)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 16 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Articles of Incorporation – Nonstock Corporation
                              </span>{' '}
                              Required for forming a nonprofit corporation in
                              Wisconsin.
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Charitable Organization Registration
                                Statement{' '}
                              </span>
                              Required for organizations soliciting charitable
                              contributions in Wisconsin.
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Charitable Organization Annual Report{' '}
                              </span>
                              Required annually to maintain good standing.{' '}
                            </li>
                          </ul>
                          <Alert
                            severity="warning"
                            icon={false}
                            sx={{ mt: 2, mb: 2 }}
                          >
                            <b>Note:</b> forms can be submitted both online and
                            on paper
                          </Alert>
                          <span style={{ fontWeight: 600 }}> Visit:</span>{' '}
                          <Link
                            href="https://dfi.wi.gov/Pages/BusinessServices/CharitableProfessionalOrganizations/OnlineServices.aspx"
                            target="_blank"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            State Portal
                          </Link>
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 16 }}>
                              Form 1023 (Application for Recognition of
                              Exemption Under Section 501(c)(3) of the Internal
                              Revenue Code): For most charitable organizations
                            </li>

                            <li style={{ marginBottom: 16 }}>
                              Form 1024 (Application for Recognition of
                              Exemption Under Section 501(a) or Section 521 of
                              the Internal Revenue Code): For other types of
                              nonprofits.
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff' }}
                              >
                                Form 990 (Return of Organization Exempt From
                                Income Tax)
                              </Link>
                              : Annual information return for tax-exempt
                              organizations.
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 5, pb: 2 }}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                px: { md: 0, sm: 0, xs: 2 },
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                State Filing Requirements for Non-Profits
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Nonprofits with a 501(c)(3) determination letter from the IRS
                may qualify for sales and use tax exemption in Wisconsin. To
                claim this exemption, organizations must:
              </Typography>
              <Box
                component="ol"
                sx={{ mb: 2, textAlign: 'left', '& li': { mb: 1.5 } }}
              >
                <li>
                  <span style={{ fontWeight: 600 }}>
                    Choose Your Entity Type{' '}
                  </span>{' '}
                  – Most nonprofits form a nonstock corporation.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    File Articles of Incorporation
                  </span>{' '}
                  – Submit to the Wisconsin Department of Financial
                  Institutions.
                </li>

                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Appoint a Registered Agent
                  </span>{' '}
                  – Must have a physical address in Wisconsin.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    Adopt Bylaws & Hold Initial Meeting
                  </span>{' '}
                  – Elect directors and approve governing documents.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}> Apply for EIN</span> –
                  Required from the IRS.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Apply for Federal Tax-Exempt Status{' '}
                  </span>{' '}
                  – File IRS Form 1023 or <br />
                  1023-EZ.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Register with Wisconsin DFI
                  </span>{' '}
                  – File Form 296 if soliciting donations in Wisconsin.
                </li>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box>
              <picture>
                <source srcSet="/assets/images/who-file-wi-img.webp" />
                <source srcSet="/assets/images/who-file-wi-img.png" />
                <img
                  src="/assets/images/who-file-wi-img.png"
                  alt="State Filing Requirements for Non-Profits"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{ px: 3, py: 3, borderRadius: 5, maxWidth: 800 }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Tax Exemption Requirements
                  </Typography>
                  {/* <Typography
                    component={'div'}
                    variant="body1"
                    sx={{ textAlign: 'center' }}
                  >
                    To gain tax-exempt status, a nonprofit must meet specific
                    requirements set by the IRS.
                  </Typography> */}
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      '& li': {
                        // float: 'left',
                        fontSize: 16,
                        display: 'flex',
                      },
                    }}
                  >
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1, mt: -0.1 }}
                      />
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Federal tax exemption:
                        </span>{' '}
                        If you want 501(c)(3) status (or other tax-exempt
                        status), file IRS Form 1023 or 1023-EZ. Wisconsin
                        follows federal recognition for many purposes.
                      </Box>
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1, mt: -0.1 }}
                      />
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Wisconsin state income/franchise tax:
                        </span>{' '}
                        Federally exempt 501(c)(3) organizations are
                        automatically exempt from Wisconsin corporate franchise
                        and income taxes. No additional filing required for that
                        exemption.
                      </Box>
                    </li>

                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1, mt: -0.2 }}
                      />
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Sales & use tax exemption (CES number):
                        </span>{' '}
                        To make exempt purchases, nonprofits with IRS 501(c)(3)
                        status (or qualifying religious organizations) may apply
                        for CES number via Form S-103. Past law changes (e.g.
                        2021 Act 1) broadened some eligibility.
                      </Box>
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Deadlines for Non-Profit Forms
              </Typography>
              {/* <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                Adhering to filing deadlines is essential to avoid penalties and
                maintain compliance.
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'left' }}>
                Below are the key deadlines for non-profit filings in West
                Virginia:
              </Typography> */}
            </Grid>
            <Grid size={12} className="responsive">
              {' '}
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Wisconsin Department of Financial Institutions (DFI)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 330,
                          }}
                        >
                          Charitable Organization Registration Renewal
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          July 31 each year. Must be filed online by this date.
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Annual Financial Report forms (Forms 1943 / 1952 /
                          308)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Within 12 months after the organization’s fiscal year
                          end. No Fee.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Form 990 Series
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due on the 15th day of the 5th month after the
                          organization&apos;s accounting period ends <br />
                          <b>Example:</b> For calendar year organizations, Form
                          990 is due by May 15
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 1023/1023-EZ
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed within 27 months of incorporation to
                          receive retroactive exemption to the date of
                          incorporation
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            {/* <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    mb: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=wisconsin`}
                >
                  E-file Now with TaxZerone
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 3,
              textAlign: 'center',
            }}
          >
            Registration & Annual Filing (Non-Profits)
          </Typography>
          {/* <Typography
            variant="body1"
            sx={{ fontSize: { md: 17, sm: 16, xs: 15 }, textAlign: 'center' }}
          >
            To operate legally as a non-profit in West Virginia, organizations
            must file the{' '}
            <span style={{ fontWeight: 600 }}>Articles of Incorporation</span>{' '}
            <Hidden smDown>
              <br />
            </Hidden>
            with the Secretary of State and pay the $25 filing fee.
          </Typography> */}

          <Grid
            container
            spacing={2}
            sx={{ mt: 4, mb: 4, px: { md: 11, sm: 2, xs: 0 } }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Initial Registration
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    1. Choose a Name
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li>
                      Must include a corporate designator (Corporation, Inc.,
                      Co., etc.) or equivalent.
                    </li>
                    <li>
                      Must be distinguishable from existing registered entities
                      (check WI DFI business entity search).
                    </li>
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    2. Appoint a Registered Agent
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li>
                      Registered agent must have a physical Wisconsin address.
                      Not P.O. box only.
                    </li>
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    3. File Form 102 – Articles of Incorporation (Nonstock
                    Corporation)
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li>
                      With DFI. Fee $35. Optionally include “delayed effective
                      date” (up to 90 days) if desired.
                    </li>
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    4. Hold Initial Corporate Meeting & Adopt Bylaws
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li style={{ marginTop: 10 }}>
                      Though bylaws are internal, adopt them; set board,
                      officers.
                    </li>
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    5. Obtain an EIN
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li style={{ marginTop: 10 }}>
                      Apply for an Employer Identification Number (EIN) from the
                      IRS.
                    </li>
                    <li>
                      Required for opening a bank account, hiring employees, and
                      applying for tax exemption.{' '}
                    </li>
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    6. Register as Charitable Organization if Applicable
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li style={{ marginTop: 10 }}>
                      <span style={{ fontWeight: 600 }}> Form 296 –</span>{' '}
                      Charitable Organization Registration Statement
                    </li>
                    <li>
                      Send you complete Form to: <br />
                      WI Department of Financial Institutions <br />
                      PO Box 7879 <br />
                      Madison, WI 53707-7879 <br />
                      Fax: (608) 267-6813
                    </li>
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                    7. Apply for Federal Tax-Exempt Status
                  </Typography>
                  <Typography variant="body1" sx={{}}>
                    File IRS Form 1023, 1023-EZ, or 1024 to obtain your 501(c)
                    status.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Annual Filing Requirements
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600, mb: 0 }}>
                    1. Charitable Organization Annual Report
                  </Typography>

                  <Box
                    component="ul"
                    sx={{ mb: 2, ml: -1, '& li': { mb: 1.2 } }}
                  >
                    <li>
                      <span style={{ fontWeight: 600 }}> Form:</span> Form 308
                    </li>

                    <li>
                      <span style={{ fontWeight: 600 }}>
                        Required annually to maintain good standing
                      </span>
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>Filing Fee:</span> $15
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>Due Date:</span>{' '}
                      Annually on the anniversary of incorporation.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>File online:</span>{' '}
                      <Link
                        href="https://dfi.wi.gov/Pages/Home.aspx"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Wisconsin DFI eFiling Portal
                      </Link>
                    </li>
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 600, mb: 0 }}>
                    2. Affidavit in Lieu of Annual Financial Report
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -1, '& li': { mb: 1.2 } }}
                  >
                    <li>
                      <span style={{ fontWeight: 600 }}> Form:</span> Form 1943
                    </li>
                    <li>
                      Required if received less than $25,000 in contributions
                      during the most recently completed fiscal year.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}> Filing Fee: </span> $15
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}> Due Date: </span>{' '}
                      Annually on the anniversary of incorporation.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}> File online: </span>{' '}
                      <Link
                        href="https://dfi.wi.gov/Pages/Home.aspx"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Wisconsin DFI eFiling Portal
                      </Link>
                    </li>
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 600, mb: 0 }}>
                    3. Wisconsin Supplement to Financial Report
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -1, '& li': { mb: 1.2 } }}
                  >
                    <li>
                      <span style={{ fontWeight: 600 }}> Form:</span> Form 1952
                    </li>
                    <li>
                      Required if filing IRS Form 990, 990-EZ, or 990-PF.{' '}
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}> Filing Fee: </span> $15
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}> Due Date: </span>{' '}
                      Annually on the anniversary of incorporation.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}> File online: </span>{' '}
                      <Link
                        href="https://dfi.wi.gov/Pages/Home.aspx"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Wisconsin DFI eFiling Portal
                      </Link>
                    </li>
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 600, mb: 0 }}>
                    4. File IRS Form 990 (Federal Requirement)
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -1, '& li': { mb: 1.2 } }}
                  >
                    <li>
                      File annually based on your fiscal year (Form 990, 990-EZ,
                      or 990-N).
                    </li>
                    <li>
                      Failure to file for three consecutive years may result in
                      IRS revocation of tax-exempt status.{' '}
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Reliable Filing Services for Tax-Exempt Organizations
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone helps nonprofits simplify IRS filing and annual reporting
          requirements.
        </Typography>
        {/* <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=wisconsin`}
          >
            E-File Now
          </Button>
        </Box> */}
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. How much does it cost to incorporate a nonprofit in
                  Wisconsin?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      The filing fee for the Articles of Incorporation is $35.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. When is the annual report due?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 0 }}>
                      The annual report is due on the anniversary of your
                      nonprofit&apos;s incorporation.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What is the annual report fee?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      The filing fee for the annual report is $15.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Do Wisconsin nonprofits need to register for charitable
                  solicitation?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Yes, if your organization solicits donations in Wisconsin,
                      you must register with the Wisconsin Department of
                      Financial Institutions by filing Form 296.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Do I still need to file IRS Form 990 if I file the state
                  annual report?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Yes, the state annual report does not replace your federal
                      filing obligations.
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Sources and References
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    {/* <Typography
                      component={'div'}
                      variant="body2"
                      sx={{ mt: 1 }}
                    >
                      This resource guide is compiled from authoritative
                      sources, including:
                    </Typography> */}
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        <Link
                          href="https://dfi.wi.gov/Pages/Home.aspx"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Wisconsin - Department of Financial Institutions
                        </Link>{' '}
                      </li>
                      <li>
                        <Link
                          href="https://dfi.wi.gov/Pages/BusinessServices/CharitableProfessionalOrganizations/Forms.aspx"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Wisconsin - Charitable Organizations
                        </Link>{' '}
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="https://www.irs.gov/charities-and-nonprofits"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          IRS – Charities and Non-Profits
                        </Link>
                      </li>{' '}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ExemptWisconsin;
